var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-of-service-modal"},[_c('md-dialog',{ref:"dialog",staticClass:"terms-of-service-modal-dialog"},[_c('md-dialog-content',[_c('terms-of-service')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }